<template>
    <div class="deliverySection">
        <div class="solutionContainer">
            <div class="solutionSection">
                <picture class="solutionImg deliveryImgComment">
                    <source :srcset="require('@/assets/solutions/specialist-supply-chain.webp')" type='image/webp' />
                    <img src="../assets/solutions/specialist-supply-chain.png" alt="graphique des partenaires de livraison de GMA Colissimo Mondial Relay DHL" loading="lazy" />
                </picture>
                <div class="solutionContent">
                    <h3 class="solutionH3">{{ $t('delivery.title') }}</h3>
                    <h4 class="solutionsIntro">{{ $t('delivery.subtitle') }}</h4>
                    <div class="solutionText"> 
                        {{ $t('delivery.paragraph1') }}
                    </div>
                    <div class="isExpanded">
                        <div class="expandedSection">
                            <div class="paraf">
                                <div class="expandedTxt expandedP1">
                                    {{ $t('delivery.paragraph2') }}
                                </div>
                            </div>
                            <div class="paraf">
                                <div class="expandedTxt expandedP2">
                                    {{ $t('delivery.paragraph3') }}
                                </div>
                            </div>
                            <div class="customerComment">
                                   <!-- <picture class="customerImg">
                                    <source :srcset="require('@/assets/solutions/avis-client-GMA.webp')" type='image/webp' />
                                    <img :src="require('@/assets/solutions/avis-client-GMA.jpg')" alt="Visage d'un client donnant son avis sur nos solutions de stockage" loading="lazy" />
                                </picture> -->
                                 <picture class="quote">
                                    <source :srcset="require('@/assets/icons/temoignage-GMA.webp')" type='image/webp' />
                                    <img :src="require('@/assets/icons/temoignage-GMA.png')" alt="Guillemets" loading="lazy" />
                                </picture>
                                <div class="commentSection">
                                    <div class="commentText">{{ $t('delivery.comment') }}</div>
                                    <div class="commentDetails">
                                        <div>Manon Trévigne</div>
                                        <div>{{ $t('delivery.function') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.deliverySection {
    margin: 115px auto 50px;
    padding: 0 30px;
    max-width: 1440px;
}
.solutionSection {
    flex-direction: row-reverse;
}
.solutionContent {
    margin-left: 0;
    margin-right: calc(30% - 50px);
    padding-right: calc(15% - 40px);
    padding-left: 70px;
    border-radius: 30px;
}
.expandedSection {
    margin-left: 0;
}
.solutionImg {
    background-color: #ffffff;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
    margin-right: 0;
    max-width: 530px;
}
@media screen and (min-width: 2000px ) {
    .deliverySection {
        padding: 50px 0;
    }
}
@media screen and (max-width: 750px ) {
    .solutionSection {
        flex-direction: column;
    }
    .solutionContent {
        margin-left: 0;
        margin-right: 0;
        padding-right: 20px;
        padding-left: 20px;
    }
    .deliverySection {
        margin: 40px 0 50px;
    }
    .deliveryImgComment {
        top: -4%;
    }
}
</style>